import { useHistory } from 'react-router-dom';

import { TrackingApi } from 'api/TrackingApi';
import { VisitsApi } from 'api/VisitsApi';
import { IS_USER_BANNED_OR_DELETED_STATUS_CODE } from 'helpers/constants';
import {
  getSessionStorageItem,
  setSessionStorageItem,
} from 'helpers/sessionStorage';
import { useRegistrationAnalytics } from 'hooks/analytics/useRegistrationAnalytics';
import { useSystemSearchQueries } from 'hooks/useSystemSearchQueries';

export const TRACK_START_APP_SESSION_STORAGE_KEY = 'TRACK_START_APP';
export const TRANSLATIONS_BUILD_VERSION_SESSION_STORAGE_KEY =
  'TRANSLATIONS_BUILD_VERSION';
export const AUTOLOGIN_TOKEN_NOT_FOUND_ERROR_MESSAGE = 'Token not found';

let isUserBanned = false;

export const useSessionStartTrack = () => {
  const history = useHistory();
  const { getAutoLoginQuery, getMFQuery } = useSystemSearchQueries();
  const { trackRegistrationSuccess } = useRegistrationAnalytics();

  const trackStartSession = async (isSaveEvent?: boolean) => {
    const { value: autologinToken } = getAutoLoginQuery();
    const { value: mfQuery } = getMFQuery();
    const isAlreadyTracked = getSessionStorageItem(
      TRACK_START_APP_SESSION_STORAGE_KEY
    );
    let translationsBuildVersion = '';

    if (isAlreadyTracked) {
      try {
        const { data } = await VisitsApi.getTranslationBuildId();

        if (data.trans_build_id) {
          return data.trans_build_id;
        }
      } catch (err) {
        console.error(err);
      }

      return translationsBuildVersion;
    }

    if (autologinToken) {
      try {
        const { trans_build_id: buildVersion } = await TrackingApi.track({
          autologinToken,
        });

        translationsBuildVersion = String(buildVersion);

        trackRegistrationSuccess();
      } catch (err: any) {
        console.error(err);
        if (err?.response?.status === IS_USER_BANNED_OR_DELETED_STATUS_CODE) {
          history.push('/login', {
            errorCode: IS_USER_BANNED_OR_DELETED_STATUS_CODE,
          });
          isUserBanned = true;
        }
      }
    } else {
      try {
        const { trans_build_id: buildVersion } = await TrackingApi.track({
          mfQuery: mfQuery || undefined,
        });

        translationsBuildVersion = String(buildVersion);
      } catch (err) {
        console.error(err);
      }
    }

    if (isSaveEvent && !isUserBanned) {
      setSessionStorageItem(TRACK_START_APP_SESSION_STORAGE_KEY, '1');
    }

    return translationsBuildVersion;
  };

  return {
    trackStartSession,
  };
};
